export enum ServiceCardEnum {
  Cleaning = "cleaning",
  Repair = "repair",
}
